import { render, staticRenderFns } from "./WorkerListItem.vue?vue&type=template&id=668d2cab&"
import script from "./WorkerListItem.vue?vue&type=script&lang=js&"
export * from "./WorkerListItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkerListItem.vue?vue&type=style&index=0&id=668d2cab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports